export default __webpack_public_path__ + "static/media/3N.1ffe95b6.jpg";